import { CompanyData } from './../../../types/constants';

import cyrupBg from './../../../assets/img/cyrup_bg.jpg';
import { projects } from './projects';

export const cyrup: CompanyData = {
  id: 3,
  name: 'Cyrup Pvt Ltd',
  country: 'Sri Lanka',
  bg: cyrupBg,
  position: 'Software Engineer',
  time: 'Dec 2016 - Jul 2019 (2 Years 7 Months)',
  description:
    'They are an agency focusing on helping digital product-driven organizations to build the minimum viable product, find the product market fit and scale up. The mother company of Cyrup Sri Lanka is based in Singapore. During my tenure with Cyrup, I got the opportunity to engage in different exciting projects expanding my professional skills and expertise.',
  projects: projects,
};
